import createIcon from '../../createIcon';

/**
 * @component @name PersonAdd
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTUgMTJDMTcuMjEgMTIgMTkgMTAuMjEgMTkgOEMxOSA1Ljc5IDE3LjIxIDQgMTUgNEMxMi43OSA0IDExIDUuNzkgMTEgOEMxMSAxMC4yMSAxMi43OSAxMiAxNSAxMlpNNiAxMFY3SDRWMTBIMVYxMkg0VjE1SDZWMTJIOVYxMEg2Wk0xNSAxNEMxMi4zMyAxNCA3IDE1LjM0IDcgMThWMjBIMjNWMThDMjMgMTUuMzQgMTcuNjcgMTQgMTUgMTRaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const PersonAdd = createIcon('PersonAdd', [
  [
    'path',
    {
      d: 'M15 12C17.21 12 19 10.21 19 8C19 5.79 17.21 4 15 4C12.79 4 11 5.79 11 8C11 10.21 12.79 12 15 12ZM6 10V7H4V10H1V12H4V15H6V12H9V10H6ZM15 14C12.33 14 7 15.34 7 18V20H23V18C23 15.34 17.67 14 15 14Z',
      key: '6lqgg9',
    },
  ],
]);

export default PersonAdd;
